import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import Text from 'components/common/Text'
import { Color } from 'constants/color'
import { _isTeacher } from 'store/selectors/User'

import Choices from './Choices'
import Header from './Header'
import * as Styles from './styles'

import { textStyles } from '../Choice/styles'
import MathJaxComponent from '../MathJaxComponent'
import { UnattemptedStudentsList } from '../MiscQuizInfo'
import QuizContainerBorder from '../QuizContainerBorder'
import Timer from '../Timer'

const QuestionsLayout = props => {
    const isTeacher = useSelector(_isTeacher)

    const memoizedQuestion = useMemo(
        () => <MathJaxComponent text={props.question?.question} />,
        [props.question]
    )

    return (
        <Styles.Container>
            <Styles.ViewScreen>
                {props.isTimerOver && (
                    <Header choices={props.choices} isTeacher={isTeacher} />
                )}
                <Styles.TimerWrapper>
                    {props.timer ? (
                        <Timer
                            max={props.question?.timer}
                            value={props.timer}
                            hide={props.isTimerOver}
                        />
                    ) : null}
                </Styles.TimerWrapper>
                <Styles.FlexLayout isTimerOver={props.isTimerOver}>
                    <Text color={Color.black} level="6" css={textStyles}>
                        {memoizedQuestion}
                    </Text>
                    <Choices
                        quesUuid={props.question?.uuid}
                        isTeacher={isTeacher}
                        choices={props.choices}
                        isTimerOver={props.isTimerOver}
                    />
                    {isTeacher && props.isTimerOver && (
                        <UnattemptedStudentsList choices={props.choices} />
                    )}
                </Styles.FlexLayout>
            </Styles.ViewScreen>
            <QuizContainerBorder />
        </Styles.Container>
    )
}

export default QuestionsLayout
